export const isPrerender = () => {
  if (typeof window !== 'undefined') {
    if (window.__REACT_SNAP__ || typeof window.snapSaveState === 'function') {
      return true;
    }
  }

  if (typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || '';
  return ua.includes('ReactSnap') || ua.includes('HeadlessChrome');
};
